'use client';
import KEYBlue from '@/components/common/keylist-blue';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import MetaTags from '@/components/meta-tag/meta-tag';
import { Tabs } from 'flowbite-react';
import BorderEdge from '@/components/common/border-edge';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="We developed a subscription-based online discount platform that offers subscribers 
exclusive discounts, deals and offers from various restaurant chains and online 
retailers."
                alt="Enjoy Stevie"
                title="Enjoy Stevie"
                width={1090}
                height={604}
                path={'enjoystevie-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Subscription-based Online Discount Platform
            </TechHero>
            <div className="section-py">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-8 lg:col-start-3 grid">
                            <h2 className="mb-5 fw-700 fs-xl">About Project</h2>
                            <p className="mb-0 text-secondary">
                                We have developed a website and native mobile apps for Enjoy Stevie and helped them to target
                                customers with a comprehensive set of interactive features for subscription and discount
                                management. We have designed and shaped the web and mobile app presence of Enjoy Stevie to allow
                                their customers to reap discount opportunities and deals for food, drinks, shopping, entertainment
                                and a whole array of other categories.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Key Challenges start */}
            <div className="section-py case-study-main bg-grey py-100 dark:text-light">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12 bs-gy-10">
                        <div className="xl:col-span-5 lg:col-span-5 md:col-span-12">
                            <div className="key-challenges-image">
                                <Image
                                    src="/img/icons/img-key-challenge.svg"
                                    className="img-fluid"
                                    alt="key-challenges"
                                    title="key-challenges"
                                    width={459}
                                    height={470}
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        <div className="xl:col-span-6 xl:col-start-7 lg:col-span-6 md:col-span-12">
                            <div>
                                <h2 className="mb-5 fw-700 fs-xl">Key Challenges</h2>
                                <p className="fs-md fw-400 mb-5">
                                    The key challenges faced by Enjoy Stevie in running their discount platform include the
                                    following.
                                </p>
                                <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                    <KEYBlue
                                        text="The main challenge was to build a single and comprehensive
              online subscription management platform for both web and
              mobile."
                                    />
                                    <KEYBlue
                                        text="The second important requirement was to allow the creation
              of landing pages for registered customers within a quick
              time."
                                    />
                                    <KEYBlue
                                        text="Another important challenge was to accommodate a large
              number of brands with their discount offers within a single
              interface synced across browsers and mobile platforms."
                                    />
                                    <KEYBlue
                                        text="A crucial challenge was to deliver a consistent user
              interface and user experience irrespective of whether the
              customer interacts through web browser or mobile apps."
                                    />
                                    <KEYBlue
                                        text="The last challenge was to create several different email
              templates to specific targeting and retargeting campaigns."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Key Challenges end */}
            {/* Case study Our Solutions start */}
            <section className="section-py case-study-main ">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12 bs-gy-10">
                        <div className="xl:col-span-6 lg:col-span-6 md:col-span-12 order-2 lg:order-1">
                            <div>
                                <h2 className="mb-5 fw-700 fs-xl">Our Solutions</h2>
                                <p className=" fs-md fw-400 text-secodary mb-5">
                                    Based upon the above-mentioned challenges, the software development team at Moweb provided the
                                    following solutions for their web and mobile app projects.
                                </p>
                                <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                    <KEYBlue text="We integrated payment gateways and relevant applications in the backend to facilitate smooth payment processing across all platforms." />
                                    <KEYBlue text="We developed pre-configured modules to build customer-centric landing pages within 10-15 minutes of time." />
                                    <KEYBlue text="We developed a single and comprehensive backend module to accommodate multiple brand and discount details within a single form." />
                                    <KEYBlue text="We designed and developed a consistent user interface for both the website and mobile apps of Enjoy Stevie for seamless customer interactions." />
                                    <KEYBlue text="We helped them with custom-built email templates to help their campaigns." />
                                </div>
                            </div>
                        </div>
                        <div className="xl:col-start-8 xl:col-span-5 lg:col-span-5 md:col-span-12 order-1 lg:order-2">
                            <div className="key-challenges-image">
                                <Image
                                    src="/img/icons/img-solutions.svg"
                                    className="img-fluid"
                                    alt="our-solutions"
                                    title="our-solutions"
                                    height={493}
                                    width={533}
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Case study Our Solutions end */}
            {/* Web & Mobile App Features start */}
            <div className="section-py case-study-main bg-grey py-100 dark:text-light">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12 bs-gy-10">
                        <div className="xl:col-span-5 lg:col-span-5 md:col-span-12">
                            <div className="key-challenges-image">
                                <Image
                                    src="/img/icons/img-web-app.svg"
                                    className="img-fluid"
                                    alt="Web & Mobile App Features"
                                    title="Web & Mobile App Features"
                                    width={520}
                                    height={457}
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        <div className="xl:col-span-6 xl:col-start-7 lg:col-span-6 md:col-span-12">
                            <div>
                                <h2 className="mb-5 fw-700 fs-xl">Web & Mobile App Features</h2>
                                <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                    <KEYBlue text="Integrated payment gateways" />
                                    <KEYBlue text="Robust user interface showcasing discount brands" />
                                    <KEYBlue text="Campaign specific landing pages" />
                                    <KEYBlue text="An array of custom email templates" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Web & Mobile App Features end */}
            {/* Value Propositions start */}
            <section className="section-py case-study-main ">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12 bs-gy-10">
                        <div className="xl:col-span-6 lg:col-span-6 md:col-span-12 order-2 lg:order-1">
                            <div>
                                <h2 className="mb-5 fw-700 fs-xl">Value Propositions</h2>
                                <p className=" fs-md fw-400 text-secodary mb-5">
                                    The web and mobile app we created for Enjoy Stevie offered the following value propositions.
                                </p>
                                <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                    <KEYBlue text="Easy and simple online subscription processing through browsers and mobile apps." />
                                    <KEYBlue text="Creating new landing pages in minutes for new customers." />
                                    <KEYBlue text="Easier customer engagement through interactive interface with discount and product details." />
                                    <KEYBlue text="Anytime, anywhere access to discounts and deals through mobile interactions." />
                                    <KEYBlue text="Targeting individual customers getting easier through custom email templates." />
                                </div>
                            </div>
                        </div>
                        <div className="xl:col-start-8 xl:col-span-5 lg:col-span-5 md:col-span-12 order-1 lg:order-2">
                            <div className="key-challenges-image">
                                <Image
                                    src="/img/icons/img-value-propositions.svg"
                                    className="img-fluid"
                                    alt="value-propositions"
                                    title="value-propositions"
                                    height={470}
                                    width={445}
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Value Propositions end */}
            {/* Technology Stack start */}
            <div className="section-py bg-grey py-100 dark:text-light">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid lg:grid-cols-12 mb-30">
                        <div className="text-center lg:col-span-6 lg:col-start-4 grid">
                            <h2 className="mb-2.5 fw-700 fs-xl">Technology Stack</h2>
                            <p className="mb-0 text-secondary">
                                We&apos;ve successfully applied these technologies and presenting this kind of case study.
                            </p>
                        </div>
                    </div>
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-8 lg:col-start-3 grid">
                            <Tabs.Group className="items-center	tab-items" aria-label="underline tabs" style="underline">
                                <Tabs.Item active title="Android Apps">
                                    <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3">
                                        <div className="tech-box">
                                            <Image
                                                src="/img/icons/ic-tech-java.svg"
                                                className="img-fluid mb-1"
                                                alt="Java"
                                                title="Java"
                                                height={50}
                                                width={50}
                                            />
                                            <p className="fs-md fw-700 mb-0">Java</p>
                                        </div>
                                        <div className="tech-box">
                                            <Image
                                                src="/img/icons/ic-tech-retrofit.svg"
                                                className="img-fluid mb-1"
                                                alt="Java"
                                                title="Java"
                                                height={50}
                                                width={50}
                                            />
                                            <p className="fs-md fw-700 mb-0">Retrofit</p>
                                        </div>
                                        <div className="tech-box">
                                            <Image
                                                src="/img/icons/ic-tech-mvc.svg"
                                                className="img-fluid mb-1"
                                                alt="Java"
                                                title="Java"
                                                height={50}
                                                width={50}
                                            />
                                            <p className="fs-md fw-700 mb-0">MVC</p>
                                        </div>
                                    </div>
                                </Tabs.Item>
                                <Tabs.Item title="iOS Apps">
                                    <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2">
                                        <div className="tech-box">
                                            <Image
                                                src="/img/icons/ic-tech-java.svg"
                                                className="img-fluid mb-1"
                                                alt="Java"
                                                title="Java"
                                                height={50}
                                                width={50}
                                            />
                                            <p className="fs-md fw-700 mb-0">Swift</p>
                                        </div>
                                        <div className="tech-box">
                                            <Image
                                                src="/img/icons/ic-tech-mvc.svg"
                                                className="img-fluid mb-1"
                                                alt="Java"
                                                title="Java"
                                                height={50}
                                                width={50}
                                            />
                                            <p className="fs-md fw-700 mb-0">MVC</p>
                                        </div>
                                    </div>
                                </Tabs.Item>
                                <Tabs.Item title="Web">
                                    <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2">
                                        <div className="tech-box">
                                            <Image
                                                src="/img/icons/ic-tech-java.svg"
                                                className="img-fluid mb-1"
                                                alt="Java"
                                                title="Java"
                                                height={50}
                                                width={50}
                                            />
                                            <p className="fs-md fw-700 mb-0">MVC</p>
                                        </div>
                                        <div className="tech-box">
                                            <Image
                                                src="/img/icons/ic-tech-mvc.svg"
                                                className="img-fluid mb-1"
                                                alt="Java"
                                                title="Java"
                                                height={50}
                                                width={50}
                                            />
                                            <p className="fs-md fw-700 mb-0">CodeIgniter</p>
                                        </div>
                                    </div>
                                </Tabs.Item>
                            </Tabs.Group>
                        </div>
                    </div>
                </div>
            </div>
            {/* Technology Stack end */}
            <BorderEdge color="text-white" bg="bg-blue" />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
